module.exports = __webpack_public_path__ + "SCTProfessional/static/dist/img/banner_registrazione.6c41e80a.png";